export default "__VITE_ASSET__488531cb__"